import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";

import { AUTHORIZATION_URL } from "../../../constants/constants";
import loginPicture from "../../../images/karte-grey-1920x1200.jpg";

import LoginButton from "../LoginButton";
import AuthWindow from "../AuthWindow";

export const LoginPageComponent = ({ loggedIn, oAuthError }) => {
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  return loggedIn ? (
    <Navigate to={from} replace />
  ) : (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        size={{ xs: 12, sm: 4, md: 7 }}
        sx={{
          display: { xs: "none", sm: "block" },
          backgroundImage: `url(${loginPicture})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid size={{ xs: 12, sm: 8, md: 5 }} component={Paper} elevation={6} square>
        <Box
          sx={theme => ({
            margin: theme.spacing(4, 0, 28),
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "calc(100% - 256px)",
          })}
        >
          <Avatar sx={theme => ({ margin: theme.spacing(1), bgcolor: "secondary.main" })}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <LoginButton />
          <AuthWindow authorizationUrl={AUTHORIZATION_URL} />
          {oAuthError && <Typography variant="body1">{oAuthError}</Typography>}
        </Box>
      </Grid>
    </Grid>
  );
};

LoginPageComponent.defaultProps = {
  oAuthError: null,
};

LoginPageComponent.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  oAuthError: PropTypes.string,
};

const mapStateToProps = state => ({
  loggedIn: state.oauth.loggedIn,
  oAuthError: state.oauth.error,
});

const LoginPage = connect(mapStateToProps)(LoginPageComponent);

export default LoginPage;
